import React, { useEffect, useRef } from 'react';
import PipelineDiagram from './PipelineDiagram';

const Blocks = ({ blocks }) =>
  blocks.map((block, i) =>
    Array.isArray(block) ? (
      <ul key={i}>
        {block.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    ) : (
      <p key={i}>{block}</p>
    )
  );

const ExperiencePage = ({ entry }) => {
  const headingRef = useRef(null);
  const technicalRef = useRef(null);

  const goToTechnical = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    technicalRef.current.focus({ preventScroll: true });
    technicalRef.current.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  useEffect(() => {
    headingRef.current.focus({ preventScroll: true });
  }, [entry.id]);

  return (
    <article className="story">
      <div className="story-nav">
        <a className="back" href="#/">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
          Back
        </a>
        {entry.technical && (
          <div className="technical-cta">
            <span className="technical-arrows" aria-hidden="true">
              {[0, 1, 2].map((i) => (
                <svg viewBox="0 0 24 24" style={{ '--i': i }} key={i}>
                  <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
              ))}
            </span>
            <button className="technical-link" type="button" onClick={goToTechnical}>
              Technical details
            </button>
          </div>
        )}
      </div>

      <img className="story-logo" src={entry.logo} alt="" />
      <h1 className="story-title" ref={headingRef} tabIndex={-1}>
        {entry.org}
      </h1>
      <p className="story-meta">
        {entry.role}, {entry.location}
        <br />
        {entry.dates}
      </p>

      {entry.sections.map((section, index) => (
        <section key={index}>
          {section.heading && <h2>{section.heading}</h2>}
          <Blocks blocks={section.blocks} />
        </section>
      ))}

      {entry.preview && (
        <a className="preview" href={entry.preview.href} target="_blank" rel="noopener noreferrer">
          <img src={entry.preview.image} alt="" />
          <span className="preview-body">
            <span className="preview-title">{entry.preview.title}</span>
            <span className="preview-description">{entry.preview.description}</span>
            <span className="preview-site">{entry.preview.site}</span>
          </span>
        </a>
      )}

      {entry.stack && <p className="story-stack">Built with {entry.stack.join(', ')}</p>}

      {entry.technical && (
        <section className="technical">
          <h2 ref={technicalRef} tabIndex={-1}>
            Technical details
          </h2>
          <PipelineDiagram />
          <Blocks blocks={entry.technical} />
        </section>
      )}
    </article>
  );
};

export default ExperiencePage;
